import { Counts, Error, MainStatus } from './data';

export class Currency {
    success: true|false;
    results: string;
    error: Error;
    counts: Counts;
    data: CurrencyData[] = [];
}

export class CurrencyData {
    ref: number;
    currencyRef: number;
    name: string;
    code: string;
    symbol: string;
    isDefault: boolean;
    status: MainStatus;
    created: string;
    lastModified: string;
}
